import * as React from 'react';

import { createIcon } from '../Icon';
export const DollarCircleIcon = createIcon(
  <React.Fragment>
    <circle cx={12} cy={12} r={10} />
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
    <line x1={12} x2={12} y1={6} y2={18} />
  </React.Fragment>,
  'DollarCircleIcon'
);
